module.exports = __webpack_public_path__ + "static/img/banner2.a60df395.png";